<template>
  <div style="display: flex;flex-direction: column;">
    <div v-if="sortList" style="margin-bottom: 20px">排序条件：
      <el-tag closable @close="deleteSort">
        {{ sortList }}
      </el-tag>
    </div>
    <div v-if="searchConditionTag.length">筛选条件：

      <el-tag
        v-for="(item,index) of searchConditionTag"
        :key="index"
        closable
        @close="deleteSelect(item,index)"
        style="margin-right: 10px;margin-bottom: 20px"
      >
        {{ item.title }}：{{ item.value }}
      </el-tag>
    </div>

  </div>
</template>

<script>
export default {
  name: "SearchSortTag",
  props:['sortList','searchConditionTag'],
  methods:{
    deleteSelect(item,index){
      this.$emit('deleteSelect',item,index)

    },
    deleteSort(){
      this.$emit('deleteSort')

    }
  }
}
</script>

<style scoped>

</style>
